class Transitions
{
    constructor()
    {
        this.match = gsap.matchMedia();
        
        this.init();
    }

    init()
    {

        //const animates = document.querySelectorAll('h1.anim, h2.anim, h3.anim, .anim h1, .anim h2, .anim h3, .anim h4, .anim p, .anim li, .anim .btn, .anim img, .wrap-accordion.animate');
        const animates = document.querySelectorAll('.anim');

        animates.forEach((animate, index) => {
            gsap.from(animate, {
                opacity: 0,
                y: 30,
                duration:1.25,
                ease:"power3.inOut",
               
                scrollTrigger: {
                    trigger: animate, 
                    start: "top 90%", 
                    toggleActions: "play none none none",
                },
            });
        });
       
    }
}

export default Transitions;